module.exports = "/_next/static/images/HeaderModal-e3691a5ac1966d3dae1dbade3c010871.svg";